import { render } from "./RightAside.vue?vue&type=template&id=e83a010a"
import script from "./RightAside.vue?vue&type=script&lang=js"
export * from "./RightAside.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__